export default "__VITE_ASSET__BwZVa11L__"